import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { default as SharedFeedThumb } from '@wix/da-shared-react/pkg/DeviationViews/Feed';
import PinIcon from '@wix/da-shared-react/pkg/Icons/Pin';
import { PapiDeviation } from '@wix/da-types-papi';
import s from './FeedThumb.scss';

export interface Props {
  className?: string;
  deviation: PapiDeviation;

  // Privileges
  canPin: boolean;
  canEdit: boolean;
  canDelete: boolean;

  // Actinos
  editItem: () => void;
  deleteItem: () => void;
  pinItem: () => void;
  unpinItem: () => void;

  // SharedFeedThumbProps
  withComments?: boolean;
  withWatch?: boolean;
}

const FeedThumb: React.FC<Props> = ({
  deviation,
  deviation: { isPinned },
  className,
  canPin,
  canEdit,
  canDelete,
  editItem,
  deleteItem,
  pinItem,
  unpinItem,
  withComments,
  withWatch,
}) => {
  const { t } = useTranslation();
  const extraActions = [
    canPin &&
      !isPinned && {
        label: t('widgets.feed.pin'),
        onClick: pinItem,
      },
    canPin &&
      isPinned && {
        label: t('widgets.feed.unpin'),
        onClick: unpinItem,
      },
    canEdit && {
      label: t('widgets.feed.edit'),
      onClick: editItem,
    },
    canDelete && {
      label: t('widgets.feed.delete'),
      onClick: deleteItem,
    },
  ];
  return (
    <div className={classnames(s['root'], className)}>
      {isPinned && <PinIcon withPadding className={s['pinned-icon']} />}
      <SharedFeedThumb
        deviation={deviation}
        withComments={withComments}
        withWatch={withWatch}
        extraActions={extraActions}
      />
    </div>
  );
};
FeedThumb.displayName = 'FeedThumb';

export default FeedThumb;
